import { connect } from 'react-redux';
import {} from 'store/actions/element-panel-actions';
import ElementFormulaList from 'components/feature/element-panel/annotations/_element-panel-formula-list-annotation-component';
import {
  replaceSelectedElementsContentPanel,
  replaceSelectedElementWithoutRemovingOld,
} from 'store/actions/action-creators';
import { deleteFormulaFromList } from 'store/actions/common/element-panel-actions';
import {
  initcopyFormula,
  stopCopyFormula,
  getTableMatrix,
  getCurrentOCRTable,
  getOcrTableMatrix,
} from 'store/actions/copy-formula-actions';
import {
  getHistoryForElementPanel,
  getElementFormulasWithoutLoading,
} from 'store/actions/element-panel-actions';
import { updateElementCacheByCalloutAction } from 'store/actions/element-cache-actions';

const mapStateToProps = ({ data }, ownProps) => {
  const {
    elementPanel: { elementDetails, formulaList },
    selectedProject: { id },
    selectedStatement: { statement, isOCR },
    copyFormula: { copiedFormula, copyFormulaSelectedElement },
    statementContent: {
      sectionsCache: { cache },
    },
  } = data;
  return {
    ...ownProps,
    elementDetails,
    formulaList,
    copiedFormula,
    copyFormulaSelectedElement,
    numberFormatId: statement.numberFormatId,
    selectedProjectId: id,
    isOCR,
    isCopiedFormula:
      copiedFormula &&
      copiedFormula.data &&
      copiedFormula.data.formulas &&
      copiedFormula.data.formulas.length > 0,
    sectionsCache: cache,
    stateData: data,
  };
};
const mapDispatchToProps = {
  replaceSelectedElements: replaceSelectedElementsContentPanel,
  replaceSelectedElementWithoutRemovingOld,
  formulaDeleteAction: deleteFormulaFromList,
  initcopyFormula: initcopyFormula,
  stopCopyFormula: stopCopyFormula,
  getTableMatrix,
  getOcrTableMatrix,
  getHistoryForElementPanel,
  getElementFormulasWithoutLoading,
  getCurrentOCRTable,
  updateElementCacheByCalloutAction,
};
export default connect(mapStateToProps, mapDispatchToProps)(ElementFormulaList);
